import { Select, ISelect } from "./";
import { getAreas } from "../../../apis/public.api";
import { useEffect, useState } from "react";
import { textChooser } from "../../../util/textChooser";
import { formatValuesForSelect } from "../../../helpers/utilities";

interface AreasProps extends ISelect {}

export const Areas = (props: AreasProps) => {

    const [areas, setAreas] = useState([]);

    useEffect(() => {
        getAreas().then((areasData) => {
            formatValuesForSelect(setAreas, areasData);
        })
    },[])

    return(
        <Select 
            {...props} 
            label={props?.label ?? textChooser("txt102")}
            values={areas} 
            currentValue={props.currentValue} 
        />
    )
}